type OngoingTripLike = {
  endAt: string | null;
  endFlag?: boolean;
};

export const isTripOngoing = (trip: OngoingTripLike): boolean => {
  if (trip.endFlag) return false;
  return trip.endAt === null;
};

export const ONGOING_TRIP_MAX_AGE_MS = 24 * 60 * 60 * 1000;

export const isActiveTripOngoing = (activeTrip?: {
  endFlag?: boolean;
  lastModifiedAt?: number;
} | null): boolean => {
  if (!activeTrip) return false;
  if (activeTrip.endFlag) return false;
  if (activeTrip.lastModifiedAt) {
    return Date.now() - activeTrip.lastModifiedAt < ONGOING_TRIP_MAX_AGE_MS;
  }
  return true;
};
